import React, { useEffect, useRef } from "react";
import "./UnderlineTabs.scss";

export const EDGE_ROOM = 24;

export const scrollLeftToShow = ({ scrollLeft, clientWidth, tabLeft, tabWidth }) => {
  if (tabLeft < scrollLeft + EDGE_ROOM) return Math.max(0, tabLeft - EDGE_ROOM);
  if (tabLeft + tabWidth > scrollLeft + clientWidth - EDGE_ROOM) return tabLeft + tabWidth - clientWidth + EDGE_ROOM;
  return scrollLeft;
};

const UnderlineTabs = ({ tabs, value, onChange, label }) => {
  const scrollerRef = useRef(null);

  useEffect(() => {
    const scroller = scrollerRef.current;
    const tab = scroller?.querySelector(".underline-tabs__tab.is-active");
    if (!scroller || !tab || scroller.scrollWidth <= scroller.clientWidth) return;
    const next = scrollLeftToShow({
      scrollLeft: scroller.scrollLeft,
      clientWidth: scroller.clientWidth,
      tabLeft: tab.offsetLeft,
      tabWidth: tab.offsetWidth,
    });
    if (next !== scroller.scrollLeft) scroller.scrollLeft = next;
  }, [value, tabs.length]);

  return (
    <div className="underline-tabs">
      <div ref={scrollerRef} className="underline-tabs__scroll" role="tablist" aria-label={label}>
        {tabs.map((tab) => {
          const active = tab.key === value;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={active}
              className={`underline-tabs__tab${active ? " is-active" : ""}`}
              onClick={() => !active && onChange(tab.key)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default UnderlineTabs;
